import React, { Component } from "react";
import MetricsPharmacyView from "./PharmacyMetricsView";

export default class MetricsPharmacyContainer extends Component {
  render() {
    const { details } = this.props;

    return <>{details && <MetricsPharmacyView details={details} />}</>;
  }
}
